import clsx from 'clsx';
import type { Mercury } from '@repo/types/Models';
import { useAccount } from '@/hooks/useAccount';
import SegmentsDropdown from './SegmentsDropdown';

// Extended SMS type with additional properties added during processing
export interface ProcessedSMS extends Mercury.Models.SMS {
  nodeStatus: string;
  nodes: Mercury.Models.SMS[];
  isSystemMessage?: boolean;
}

interface MessageProps {
  node: ProcessedSMS;
}

const Message = ({ node }: MessageProps) => {
  const account = useAccount();
  const accountId = account?.id;

  return (
    <div
      className={clsx(
        'flex flex-col gap-2',
        node.direction === 'INBOUND' ? 'items-end ml-auto' : 'mr-auto items-start'
      )}
    >
      <div className="flex flex-row">
        <div
          className={clsx(
            'text-gray-600 dark:text-blue-300',
            node.direction === 'INBOUND' ? 'ml-auto mr-2' : 'mr-auto ml-2'
          )}
        >
          <a
            className="text-gray-600 dark:text-blue-300"
            href={`/a/${accountId}/messaging?q=multipart_id:${node.id}`}
          >
            {node.id}
          </a>
        </div>
      </div>
      <div
        className={clsx(
          'flex flex-col max-w-3xl p-5  rounded-t-xl ',
          node.direction === 'INBOUND'
            ? ' bg-blue-200 dark:bg-blue-900 rounded-br-lg rounded-bl-2xl'
            : ' bg-green-200/80 dark:bg-green-900/80 rounded-tl-lg rounded-t-2xl rounded-r-2xl'
        )}
      >
        <div
          className={clsx(
            'text-bubble',

            `status-${node.nodeStatus.toLowerCase()}`
          )}
        >
          <div className="bubble-header">
            <div className="Icons">
              {node.isSystemMessage && (
                <span className="ml-2" title="Server Message">
                  Server
                </span>
              )}
            </div>
          </div>

          <div className="bubble-body">
            <div className="text-content">
              {node.nodes.map((childNode) => (
                <a
                  key={childNode.id}
                  className={clsx(
                    `inline hover:bg-white dark:hover:bg-blue-800 transition-colors duration-200 mr-1`,
                    childNode.status === 'UNDELIVERED' ? 'text-ghost' : ''
                  )}
                  title={`${childNode.id}: ${childNode.status}`}
                  href={`/a/${accountId}/messaging/smses/${childNode.id}`}
                >
                  {childNode.displayBody}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <SegmentsDropdown accountId={accountId} node={node} direction={node.direction} />

      <div
        className={clsx(
          'text-gray-600 dark:text-blue-300',
          node.direction === 'INBOUND' ? 'ml-auto mr-2' : 'mr-auto ml-2'
        )}
      >
        {new Date(node.insertedAt).toLocaleTimeString()}
      </div>
    </div>
  );
};

export default Message;
